import { menuFilterField } from './fields/menuFilter.field';

export const menuFilterPolicies = {
    menuFilter: menuFilterField,
};
